import type { GencowCloudFeatureId, GencowConfig } from "@gencow/core";

export function isCloudFeatureEnabled(
  config: Pick<GencowConfig, "cloudFeatures"> | undefined,
  featureId: GencowCloudFeatureId,
): boolean {
  const value = config?.cloudFeatures?.[featureId];
  return value === true || (!!value && typeof value === "object" && !Array.isArray(value));
}
